import cn from 'classnames';
import React from 'react';

import {getLocalizedStrings} from '../../../../services/localization/localizationService';
import AppButton from '../../../Button/AppButton/AppButton';
import ContentWrapper from '../../../Layout/ContentWrapper';
import styles from './InstructionStepsList.module.scss';

const InstructionStepsList = (props) => {
    const {subTitle, instructionKey, instructionButton, skipButton} = props;
    const localizedStrings = getLocalizedStrings();

    return (
        <div
            className={cn('w-full text-primary', {
                'mt-8 bg-secondary pb-10 pt-8 sm:mt-12 lg:mt-10': instructionKey,
            })}
        >
            <ContentWrapper>
                {instructionKey && (
                    <>
                        <h2 className={'mb-4 text-24 md:mb-8'}>{subTitle}</h2>
                        <ul
                            className={cn('text-start', styles.InstructionStepsList)}
                            dangerouslySetInnerHTML={{
                                __html: localizedStrings[instructionKey],
                            }}
                        />
                    </>
                )}
                {instructionButton && <AppButton {...instructionButton} />}
                {skipButton && <AppButton {...skipButton} />}
            </ContentWrapper>
        </div>
    );
};

export default InstructionStepsList;
